import { useLogStore } from "~/stores/LogStore";

export default defineNuxtRouteMiddleware(() => {
  const logStore = useLogStore();
  if (isPWA()) {
    logStore.sendPwaUsageLog();
  }
});
